// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KIeB","expireSoon":"styles_expireSoon__3Lh1f"};